import React, { createContext, useContext, useRef, useEffect, HTMLAttributes } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { UUID, AccordionContext } from './accordion';

const AccordionItemElement = styled.div`
    border-top: 1px solid;

    &:first-child {
        border-top: 0;
    }
`;

export interface IAccordionItemProps extends HTMLAttributes<HTMLDivElement> {
    autoFocus?: boolean;
    uuid: UUID;
}

export interface IItemContext {
    uuid: UUID;
    isExpanded: boolean;
}

export const ItemContext = createContext<IItemContext>(null);

export default function AccordionItem(props: IAccordionItemProps): JSX.Element {
    const componentRef = useRef(null);
    const { className, children, uuid, autoFocus } = props;
    const { expandedItems } = useContext(AccordionContext);
    const isExpanded = expandedItems.includes(uuid);
    const context = { uuid, isExpanded };

    useEffect((): void => {
        if (isExpanded && autoFocus) {
            componentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isExpanded, autoFocus]);

    return (
        <ItemContext.Provider value={context}>
            <ThemeProvider theme={context}>
                <AccordionItemElement className={className} ref={componentRef}>
                    {children}
                </AccordionItemElement>
            </ThemeProvider>
        </ItemContext.Provider>
    );
}
